// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/rating/v1/rating.proto (package fingertip.creator.rating.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Rating } from "../../../common/type/v1/rating_pb.js";
import { Asset } from "../../../common/type/v1/asset_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { Site } from "../../../common/type/v1/site_pb.js";
import { Page as Page$1 } from "../../../common/type/v1/page_pb.js";

/**
 * @generated from message fingertip.creator.rating.v1.GetSiteRatingRequest
 */
export const GetSiteRatingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.GetSiteRatingRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.GetSiteRatingResponse
 */
export const GetSiteRatingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.GetSiteRatingResponse",
  () => [
    { no: 1, name: "rating", kind: "message", T: Rating },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.DeleteSiteRatingRequest
 */
export const DeleteSiteRatingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.DeleteSiteRatingRequest",
  () => [
    { no: 1, name: "rating_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.DeleteSiteRatingResponse
 */
export const DeleteSiteRatingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.DeleteSiteRatingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.GetSiteContactRatingRequest
 */
export const GetSiteContactRatingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.GetSiteContactRatingRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.GetSiteContactRatingResponse
 */
export const GetSiteContactRatingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.GetSiteContactRatingResponse",
  () => [
    { no: 1, name: "rating", kind: "message", T: Rating },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.GetSiteRatingsRequest
 */
export const GetSiteRatingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.GetSiteRatingsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.Page
 */
export const Page = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.Page",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.UserProfile
 */
export const UserProfile = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.UserProfile",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar_asset", kind: "message", T: Asset },
    { no: 5, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.Ratings
 */
export const Ratings = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.Ratings",
  () => [
    { no: 1, name: "rating", kind: "message", T: Rating },
    { no: 2, name: "user", kind: "message", T: UserProfile },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.GetSiteRatingsResponse
 */
export const GetSiteRatingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.GetSiteRatingsResponse",
  () => [
    { no: 2, name: "ratings", kind: "message", T: Ratings, repeated: true },
    { no: 3, name: "average_rating", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "rating_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.CreateSiteRatingPublicRequest
 */
export const CreateSiteRatingPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.CreateSiteRatingPublicRequest",
  () => [
    { no: 1, name: "page_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "rating", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.CreateSiteRatingPublicResponse
 */
export const CreateSiteRatingPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.CreateSiteRatingPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.DeleteCustomerRatingRequest
 */
export const DeleteCustomerRatingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.DeleteCustomerRatingRequest",
  () => [
    { no: 1, name: "rating_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.DeleteCustomerRatingResponse
 */
export const DeleteCustomerRatingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.DeleteCustomerRatingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.GetCustomerRatingsItem
 */
export const GetCustomerRatingsItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.GetCustomerRatingsItem",
  () => [
    { no: 1, name: "rating", kind: "message", T: Rating },
    { no: 2, name: "site", kind: "message", T: Site },
    { no: 3, name: "page", kind: "message", T: Page$1 },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.GetCustomerRatingsRequest
 */
export const GetCustomerRatingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.GetCustomerRatingsRequest",
  () => [
    { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.rating.v1.GetCustomerRatingsResponse
 */
export const GetCustomerRatingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.rating.v1.GetCustomerRatingsResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: GetCustomerRatingsItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

